import * as vp from 'vopay';

type LoginFormRows = {
  label: vp.LoginFormLabel;
  id: vp.LoginFormId;
  required: boolean;
  preset: keyof vp.TextFieldPresets | undefined;
};


const buildLoginFormRows = (): LoginFormRows[] => [
  {
    label: vp.LoginFormLabel.EmailAddress,
    id: vp.LoginFormId.EmailAddress,
    required: true,
    preset: 'text',
  },
  {
    label: vp.LoginFormLabel.Password,
    id: vp.LoginFormId.Password,
    required: true,
    preset: 'password',
  },
];

export default buildLoginFormRows;
